import React from "react";
import { css } from "aphrodite";
import { Accordion, Nav, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
//import classNames from "classnames";
import styles from "./style";
import { useAccordionButton } from 'react-bootstrap/AccordionButton';

class SubSubmenu extends React.Component {
  constructor(props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
  }

  toggleNavbar() {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  render() {
    const { title, items, icon } = this.props;
    return (
      <Nav.Item>
        <Accordion flush>
        <Card style={{border : "0px"}}>
        <Card.Header className={[css(styles.navLinkStyle)]}>
          <CustomToggle eventKey="0" icon={icon} title={title} collapsed={this.state.collapsed} />
        </Card.Header>
        <Accordion.Collapse eventKey="0" >
          <Card.Body className={[css(styles.navLinkStyle)]}>
          <nav>
              {items.subMenus.map(item => (
                <a
                  className={`nav-link nav-item pl-5 ${
                    css(styles.navItemsStyle)
                  } `}
                  style={{color: "#adb5bd"}}
                  href={item.path}
                  key={item.id}
                >
                  <i className={item.iconClass} style={{paddingRight: "5px"}} />
                  {item.menuName}
                </a>
              ))}
            </nav>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
      </Accordion>
      </Nav.Item>
    );

  }
}

function CustomToggle({ children, eventKey, title, icon, callback, collapsed }) {
    
    const decoratedOnClick = useAccordionButton(eventKey, () =>
      callback && callback(eventKey),
    );


    return (
        <button onClick={decoratedOnClick} className={[css(styles.buttonStyle)]}>
        <i className={icon} style={{paddingRight: "5px"}} />
        {title}
        <FontAwesomeIcon
          icon={collapsed ? faCaretDown : faCaretUp}
          style={{float: "right"}}
        />
        </button>
    );
  }

export default SubSubmenu;
